import React, { useEffect, useRef } from 'react';
import { ButtonVariant } from "../../../button";
import { YearButtonBase } from "./helperComponents";
import { jsx as ___EmotionJSX } from "@emotion/core";
var YearButton = /*#__PURE__*/React.memo(function (_ref) {
  var hasFocus = _ref.hasFocus,
      isCurrentYear = _ref.isCurrentYear,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      year = _ref.year;
  var ref = useRef(null);

  var handleClick = function handleClick() {
    onClick(year);
  };

  useEffect(function () {
    if (hasFocus && ref.current) {
      ref.current.focus();
    }
  }, [hasFocus]);
  return ___EmotionJSX(YearButtonBase, {
    isCurrentYear: isCurrentYear,
    onClick: handleClick,
    onKeyDown: onKeyDown,
    ref: ref,
    tabIndex: isCurrentYear ? 0 : -1,
    variant: ButtonVariant.Tertiary
  }, year);
});
export default YearButton;